module.exports = require('./helpers/bundle-url').getBundleURL('kuLgW') + "redcard.dc6a6e43.png";